<script>
    import PostCard from '../components/PostCard.svelte'
    import AddressForm from '../components/AddressForm.svelte'
    import firebase from 'firebase/app'
    import Banner from '../components/Banner.svelte'
    import {navigate} from 'svelte-routing'
    import QueryString from 'query-string'
    import {cartStore, autoSaveStore} from '../model/stores'
    import NetworkButton from '../components/NetworkButton.svelte'
    import FaAngleRight from 'svelte-icons/fa/FaAngleRight.svelte'
    import {
        emitExceptionEvent,
        emitHttpExceptionEvent,
        emitPageViewEvent,
        getBasicPostcardDetails,
        getBasicPostcardItem
    } from '../actions/pageAnalytics'

    window.scrollTo(0, 0)
    export let loadOrder
    export let location
    emitPageViewEvent(location, 'Create')
    firebase.analytics().logEvent('view_item', getBasicPostcardDetails(2))
    let loadedOrderIndex
    let appliedPromo
    let order = {
        promoCode: '',
        toAddress: {},
        fromAddress: {},
        content: {
            title: '',
            message: ''
        }
    }
    const queryParams = QueryString.parse(location.search)
    if (queryParams.load && $cartStore && $cartStore[queryParams.load]) {
        order = Object.assign(order, $cartStore[queryParams.load])
        loadedOrderIndex = queryParams.load
    } else {
        if ($autoSaveStore) order = Object.assign(order, $autoSaveStore)


        if (queryParams.title) order.content.title = queryParams.title
        if (queryParams.message) order.content.message = queryParams.message
    }


    let validationResult = {}

    const isPromoCodeValid = firebase.functions().httpsCallable('isPromoCodeValid')

    async function validatePromoCode() {
        const result = await isPromoCodeValid({promoCode: order.promoCode})
        if (!result.promoCode) appliedPromo = order.promoCode
    }

    const validateOrder = firebase.functions().httpsCallable('validateOrder')
    $: autoSaveStore.set(order)

    function onOrderValid(res) {
        const validOrder = res.data
        if(!validOrder){
            const error = new Error('validate Order returned null order' + JSON.stringify(validOrder))
            emitExceptionEvent(error)
            throw error
        }
        cartStore.update(cart => {
            if (loadedOrderIndex !== undefined) {
                cart[loadedOrderIndex] = validOrder
            } else {
                cart.push(validOrder)
            }
            autoSaveStore.set(false)
            return cart
        })
        firebase.analytics().logEvent('add_to_cart', getBasicPostcardDetails(validOrder))
        if (validOrder.promoCode) {
            firebase.analytics().logEvent('select_promotion', {
                items: [getBasicPostcardItem(validOrder)],
                promotion_id: validOrder.promoCode,
                promotion_name: validOrder.promoCode
            })
        }
        navigate('/new?load=' + $cartStore.indexOf(res.data), {replace: true})
        navigate('/checkout')
        return {}
    }

    async function confirm() {
        validationResult = {}
        appliedPromo = undefined
        autoSaveStore.set(order)
        validationResult = await validateOrder(order).then(onOrderValid).catch(e => {
            emitHttpExceptionEvent(e)
            if (e.code === 'invalid-argument') return e.details
            else {
                internal:'internal-error'
            }
        })
        appliedPromo = order.promoCode.slice()
    }

    $: order.promoCode = order.promoCode.toUpperCase().trim()
</script>

<style>
    h1 {
        text-align: left;
        line-height: 1.1em;
        font-weight: bold;
    }

    .right-col {
        display: flex;
        flex-direction: column;
        width: 25rem;
        flex: none;
    }

    .left-col {
        display: flex;
        flex-direction: column;
    }

    .vr {
        margin-right: 1rem;
    }

    input[type=text] {
        width: 100%;
        margin-right: 0.5em;
    }

    @media (max-width: 60em) {
        .row {
            flex-direction: column;
            align-items: stretch;
        }

        .left-col {

            flex: auto;
        }

        .right-col {
            flex: auto;
            width: auto;
        }

        .vr {
            display: none;
        }

        .form {
            max-width: 25rem;
        }
    }
</style>
<svelte:head>
    <title>Create a Postcard</title>
</svelte:head>

<div class="parent flex flex-column relative items-center">
    <!--    <div class="heroTexture"></div>-->
    <div class="flex flex-column my3 mt4 items-center">
        <h1 class='mb3'>1. Write your note.</h1>
        <div class="flex flex-column">

            <PostCard bind:content={order.content}/>
            <!--            <h5 class='m1 grayText'>Click to edit</h5>-->
        </div>
        {#if validationResult.content && validationResult.content === 'empty-content'}
            <Banner cl='mt1 error'>
                <b>The note cannot be completely blank.</b>
            </Banner>
        {/if}
    </div>

    <hr>
    <div class="form flex flex-column">
        <div class="row flex mt2 mb2">
            <div class="left-col">
                <h2>2. Recipient's Address.</h2>
                <h5 class='self-start nearInkText mt1 regular'>We currently only support addresses in the <b>USA🇺🇸</b>
                </h5>
            </div>
            <div class="vr"></div>
            <div class="flex flex-column right-col">
                <AddressForm type='to' bind:address={order.toAddress} isError={validationResult.toAddress}/>
                {#if validationResult.toAddress}
                    <Banner cl='mt1 error'>
                        <b>We couldn't find a valid address.</b> <br>
                        <span class="icon"><FaAngleRight/></span> Make sure every field is filled. <br>
                        <span class="icon"><FaAngleRight/></span> Maybe you're missing a unit number?
                    </Banner>
                {/if}
            </div>
        </div>
        <hr>
        <div class="row flex mt2 mb2">
            <div class="left-col">
                <h2>3. Sender's Address.</h2>
                <p>If the mail cannot be delivered, it will be returned to this address.</p>
                <h5 class='self-start nearInkText mt1 regular'>We currently only support addresses in the <b>USA🇺🇸</b>
                </h5>
            </div>
            <div class="vr"></div>
            <div class="right-col">
                <AddressForm type='from' bind:address={order.fromAddress} isError={validationResult.fromAddress}/>
                {#if validationResult.fromAddress}
                    <Banner cl='mt1 error'>
                        <b>We couldn't find a valid address.</b> <br>
                        <span class="icon"><FaAngleRight/></span> Make sure every field is filled. <br>
                        <span class="icon"><FaAngleRight/></span> Street Address should not contain city or state.<br>
                        <span class="icon"><FaAngleRight/></span> Maybe you're missing a unit number?
                    </Banner>
                {/if}
            </div>
        </div>
        <hr>
        <div class="row flex mt2 mb4">
            <div class="left-col">
                <h2 class=''>4. Promo Code?</h2>
                <p>If you have a promo code, you can use it here.</p>
            </div>
            <div class="vr"></div>
            <div class="right-col">

                <div class="flex">
                    <label for="senderEmail flex-auto">Promo Code</label>
                    <span class='flex-auto'></span>
                </div>
                <input type='text' bind:value={order.promoCode} placeholder='(Optional) Promo Code'>
                {#if validationResult.promoCode}
                    <Banner cl='mt1 error' animate={true}>Invalid Promo Code: <b>{appliedPromo}</b></Banner>
                {:else if appliedPromo}
                    <Banner cl='mt1 success' animate={true}>Successfully applied <b>{appliedPromo}</b></Banner>
                {/if}
                <NetworkButton cl='mt2' action={confirm}>Continue</NetworkButton>
                {#if Object.entries(validationResult).length > 0}
                    <Banner cl='mt1 error'>
                        <b>Some fields require your attention.</b>
                    </Banner>
                {/if}
                {#if validationResult.internal}
                    <Banner cl='mt1 error'>
                        <b>Internal Error. Please try again later.</b>
                    </Banner>
                {/if}
            </div>
        </div>
    </div>
</div>
